import { NotificationState, NotificationStatus } from './components/state'
import { Toasts } from './components/Toast/ToastGroup'
const notificationState = new NotificationState()

export { notificationState, NotificationStatus, Toasts }
